import { PriceModel } from './price.model';

export class TotalPriceInfoModel {

  monthlyRecurringFee: PriceModel;
  oneTimeFee: PriceModel;
  constructor() {
    this.monthlyRecurringFee = undefined;
    this.oneTimeFee = undefined;
  }
}
